import * as React from "react";

function SvgIcNoResults(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6a5 5 0 00-4.172 7.758l6.93-6.93A4.974 4.974 0 0011 6zm4.192-.606a7 7 0 00-9.798 9.798l-1.101 1.1a1 1 0 001.413 1.416h.001l1.76-1.754a.98.98 0 00.066-.073L17.707 5.707a1 1 0 00-1.414-1.414l-1.1 1.1zm1.133 2.663a1 1 0 011.276.61A6.99 6.99 0 0118 11a6.97 6.97 0 01-1.394 4.192l3.101 3.1a1 1 0 01-1.414 1.415l-3.1-3.1A6.97 6.97 0 0111 18a6.99 6.99 0 01-2.333-.399 1 1 0 11.666-1.885 5 5 0 006.382-6.382 1 1 0 01.61-1.277z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcNoResults;
